import Builder from "./Builder.vue";
import ComboboxInput from "./ComboboxInput.vue";
import SelectInput from "./SelectInput.vue";
import TextInput from "./TextInput.vue";

export default {
  Builder,
  ComboboxInput,
  SelectInput,
  TextInput,
};
